import '../styles/global.scss'

export const Footer = () => {
    return (
        <footer>
            <p><span className='footer-year'>2023</span>Construído por Julia Lacerda</p>
        </footer>
    )
}